var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy335(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_48_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 39.1,
    cy: 24.1,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_47_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 59,
    cy: 24.1,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_44_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 49.1,
    cy: 45.2,
    rx: 4.8,
    ry: 4.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_42_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 63.1,
    cy: 39.4,
    rx: 2.6,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_30_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 35,
    cy: 39.3,
    rx: 2.6,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 49.1,
    cy: 32.9,
    r: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_29_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 35.7,
    cy: 75.6,
    rx: 8.8,
    ry: 8.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_28_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 62.4,
    cy: 75.6,
    rx: 8.8,
    ry: 8.8
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M63.5,90.3H34.6c-8,0-14.6-6.5-14.6-14.6v0c0-8,6.5-14.6,14.6-14.6h28.9c8,0,14.6,6.5,14.6,14.6v0C78.1,83.8,71.6,90.3,63.5,90.3z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy335);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-335.d492925c8b44ba4e1fc5abf5612f1f14.svg";
export { ForwardRef as ReactComponent };